import { render, staticRenderFns } from "./CoozzyRentIcon.vue?vue&type=template&id=0dada0bd&scoped=true"
import script from "./CoozzyRentIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyRentIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyRentIcon.vue?vue&type=style&index=0&id=0dada0bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dada0bd",
  null
  
)

export default component.exports